<template>
  <div>
    <p>Anda tidak memiliki hak akses ke halaman ini !!!</p>
    <p><v-btn to="/">Kembali ke Home</v-btn></p>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>